export const cloneConfigModal = {
  close: "Cerrar",
  searchPlaceholder: "Buscar alojamiento…",
  clearSearch: "Limpiar",
  bar: {
    chooseSource: "Elige el alojamiento de origen",
    selected: "{count} seleccionado | {count} seleccionados",
    selectAll: "Marcar todos",
    clear: "Desmarcar",
  },
  list: {
    loading: "Cargando alojamientos…",
    empty: "No hay alojamientos que coincidan.",
    unitsBadge: "{count} unidades",
  },
  confirm: {
    sourceLabel: "Origen elegido",
    applyToLabel: "Se aplicará a",
    andItsUnits: "(y sus {count} unidades)",
    andMore: "y {count} más",
    undoWarning: "Esta acción no se puede deshacer.",
  },
  footer: {
    back: "Volver",
    cancel: "Cancelar",
    continue: "Continuar",
  },
  preview: {
    unit: "Unidad",
    listing: "Anuncio",
    empty: "Sin configurar.",
    loading: "Cargando…",
  },
  confirmTitle: {
    pull: "Confirma antes de traer",
    push: "Revisa antes de copiar",
  },
  confirmLabel: {
    pulling: "Trayendo…",
    copying: "Copiando…",
    confirmPull: "Sí, traer configuración",
    confirmPush: "Sí, copiar a {count} alojamiento | Sí, copiar a {count} alojamientos",
  },
  intro: {
    pullLead: "Vas a traer {noun} del alojamiento que has elegido.",
    pullReplace: "Se reemplazará lo que tengas ahora aquí.",
    pullAdd: "Se sumará a lo que ya tengas aquí.",
    pushLead: "Vas a copiar {noun} a {count} alojamiento. | Vas a copiar {noun} a {count} alojamientos.",
    pushReplace: "Se reemplazará lo que tenga ahora{scope}. | Se reemplazará lo que tengan ahora{scope}.",
    pushAdd: "Se sumará a lo que ya tenga. | Se sumará a lo que ya tengan.",
    pushScope: ", incluidos los ajustes de envío",
  },
  attachments: {
    fileFallback: "Adjunto",
    titleAlsoCopied: "También se copian los adjuntos",
    titlePullLose: "Perderás los adjuntos que tienes ahora",
    titlePullGain: "También llegarán sus adjuntos",
    titlePushEmpty: "Los alojamientos elegidos se quedarán sin adjuntos",
    noteUnknownPull: "Los adjuntos del alojamiento que has elegido sustituirán a los de aquí, que se eliminarán.",
    noteUnknownPush: "Los adjuntos de este alojamiento sustituirán a los de los elegidos, que se eliminarán.",
    notePullReplace: "Se eliminarán y en su lugar llegarán los del alojamiento que has elegido.",
    notePullEmpty: "Aquí no hay ningún adjunto ahora mismo, así que no pierdes nada: llegarán los que tenga el alojamiento elegido.",
    notePushEmpty: "Este alojamiento no tiene adjuntos, así que los del alojamiento elegido se eliminarán y se quedará sin ninguno. | Este alojamiento no tiene adjuntos, así que los de los alojamientos elegidos se eliminarán y se quedarán sin ninguno.",
    notePushReplace: "Se copiarán al alojamiento elegido y sustituirán a los suyos, que se eliminarán. | Se copiarán a los alojamientos elegidos y sustituirán a los suyos, que se eliminarán.",
  },
  toast: {
    loadError: "No se pudieron cargar los alojamientos",
    pullSuccess: "Configuración traída correctamente",
    pushSuccess: "Configuración copiada a {count} alojamiento | Configuración copiada a {count} alojamientos",
    pullError: "No se pudo traer la configuración",
    pushError: "No se pudo copiar la configuración",
  },
};
